import { render, staticRenderFns } from "./ResumeEditTab.vue?vue&type=template&id=2b19b25b&scoped=true"
import script from "./ResumeEditTab.vue?vue&type=script&lang=js"
export * from "./ResumeEditTab.vue?vue&type=script&lang=js"
import style0 from "./ResumeEditTab.vue?vue&type=style&index=0&id=2b19b25b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b19b25b",
  null
  
)

export default component.exports